import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CaretRight, QrCode, LightbulbFilament, Trophy } from 'phosphor-react';

const TutorialOverlay = ({ isOpen, onClose }) => {
  const [step, setStep] = useState(1);

  const steps = {
    1: {
      icon: <LightbulbFilament size={48} className="text-yellow-400" weight="fill" />,
      title: "Przeczytaj zadanie",
      description: "Zapoznaj się dokładnie z treścią zadania i jego wymaganiami."
    },
    2: {
      icon: <QrCode size={48} className="text-blue-400" weight="fill" />,
      title: "Zeskanuj kod QR",
      description: "Znajdź kod QR powiązany z zadaniem i zeskanuj go używając przycisku 'Zeskanuj QR'."
    },
    3: {
      icon: <Trophy size={48} className="text-yellow-400" weight="fill" />,
      title: "Zbieraj punkty",
      description: "Po prawidłowym zeskanowaniu kodu, otrzymasz punkty za wykonanie zadania!"
    }
  };

  const handleNext = () => {
    if (step === 3) {
      onClose();
    } else {
      setStep(step + 1);
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-[60] p-4"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-gray-800 rounded-xl shadow-xl max-w-md w-full overflow-hidden border border-gray-700"
          >
            <div className="p-6">
              <motion.div
                key={step}
                initial={{ x: 50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -50, opacity: 0 }}
                className="text-center"
              >
                {steps[step].icon}
                <h2 className="text-xl font-bold mt-4 mb-2 text-white">{steps[step].title}</h2>
                <p className="text-gray-400 mb-6">{steps[step].description}</p>
              </motion.div>

              <div className="flex justify-between items-center">
                <div className="text-sm text-gray-500">
                  Krok {step} z 3
                </div>
                <button
                  onClick={handleNext}
                  className="bg-blue-600 text-white px-6 py-2 rounded-lg flex items-center gap-2 
                    hover:bg-blue-700 transition-colors"
                >
                  {step === 3 ? 'Rozpocznij' : 'Dalej'}
                  <CaretRight weight="bold" />
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TutorialOverlay;
